module.exports = __webpack_public_path__ + "static/media/3.c00e2349.jpeg";